function checkTime(i) {
  if (i < 10) {
      i = "0" + i;
  }
  return i;
}

function getFormattedTime() {
  var today = new Date();
  var y = today.getFullYear();
  var m = today.getMonth() + 1;
  var d = today.getDate();
  var h = today.getHours();
  var mi = today.getMinutes();
  m = checkTime(m);
  h = checkTime(h);
  return y + "-" + m + "-" + d + "-" + h + "-" + mi ;
}

export const exportJSON = (data, optionNumber) => {
  const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
    JSON.stringify(data, null, 2)
  )}`;
  const link = document.createElement("a");
  link.href = jsonString;
  link.download = `VCF-JSON-Generator_${getFormattedTime()}.json`;
  link.click();
  link.remove();
};
